<template>
  <div>
    <HeaderBreadcrumbs :items="[
      { label: 'Brand',
       to: '/ax/items/brand-ax'
      },  
      { label: 'Add New' }
    ]" title="New Brand" />
    <div class="flex-col w-full bg-white shadow-sm rounded-lg px-4 py-3">
      <div class="w-1/2">
        <h4 class="font-bold text-xl leading-7 mb-4 block">Create New Brand</h4>
        <div class="mb-3">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Item Name
          </label>
          <input id="basePrice" type="text" v-model="name" placeholder="Enter Item Name"
            class="w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2" />
        </div>
        <div class="mb-3 mr-2">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
          Brand
          </label>
          <multiselect
                v-model="brand"
                label="name"
                track-by="name"
                placeholder="Select Item Name"
                open-direction="bottom"
                required="required"
                :options="brandSearchOptions"
                :searchable="true"
                :loading="isBrandSearch"
                :close-on-select="true"
                :options-limit="10"
                :multiple="false"
                :allow-empty="false"
                @search-change="brandFind"
              >
              </multiselect>
        </div>
        <div class="mb-3">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Base Price
          </label>
          <input id="basePrice" type="number" min="0" v-model="basePrice" placeholder="Enter Base Price"
            class="w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2" />
        </div>
        <div class="mb-3">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Subscription ID AX
          </label>
          <input id="subsIdAx" type="number" min="0" v-model="subsIdAx" placeholder="Enter Single ID AX"
            class="w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2" />
        </div>  
        <div class="mt-3 mr-1.5">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Vendor
          </label>
          <multiselect v-model="vendor" label="name" track-by="name" placeholder="Select Vendor"
            open-direction="bottom" :options="items_vendor" :searchable="true" :loading="isLoadingSearch"
            :close-on-select="true" @search-change="findVendorName" @input="getVendorAx">
            <span slot="noResult">
              Oops! No elements found. Consider changing the search query.
            </span>
          </multiselect>
        </div>
        <div class="mt-3">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Vendor ID AX
          </label>
          <input id="basePrice" type="text" v-model="vendor_id_ax" placeholder="Vendor ID AX"
            class="w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2" />
        </div>
        <div class=" mt-4 mb-3 mr-0 flex justify-start">
          <button @click="addBrandAx()" class="bg-blue-600 text-white px-4 py-2 rounded-lg mr-3">Save</button>
          <button type="reset" class="bg-whit text-gray-500 border px-4 py-2 rounded-lg">
            <router-link class="text-gray-500 no-underline hover:no-underline hover:text-gray-500" size="sm"
            :to="{
              name: brandItemAx.name,
            }" 
            >
              Cancel
            </router-link>
          </button>
        </div>
      </div>
    </div>
  </div>
   
 
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { brandItemAx } from '../../router/content';
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs'
import {EventBus} from '../../event-bus'

export default {
  name: 'CreateBrandAX',
  components:{
    HeaderBreadcrumbs,
  },
  data() {
    return {
      brandItemAx,
      name: null,
      brand: [],
      brandSearchOptions: [],
      isBrandSearch: false,
      basePrice: '',
      subsIdAx: '',
      vendor: [],
      items_vendor: [],
      isLoadingSearch: false,
      vendor_id_ax: '',
    };
  },
  watch: {
    successMessage: function() {
      if (!this.successMessage) return;
       // this.alertMsg(this.successMessage, 'success');
      EventBus.$emit('show-toast', {
            message:'New brand has been added.',
            type: 'success',
          });
      this.$router.push('/ax/items/brand-ax');
    },
    errorMessage: function() {
      if (!this.errorMessage) return;
      // this.alertMsg(this.errorMessage, 'error');
      EventBus.$emit('show-toast', {
            message:this.errorMessage,
            type: 'error',
          });
    },
    isError: function() {
      if (!this.isError) return;
      this.alertMsg('Ops. Something went wrong !', 'error');
    },

    $route: {
      immediate: true,
      handler(to) {
        document.title =
          to.meta.title ||
          'Create Brand AX | Content Management System Ebooks Gramedia.com';
      },
    },
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.brandAx.isLoading,
      isError: (state) => state.brandAx.isError,
      successMessage: (state) => state.brandAx.SuccessMessage,
      errorMessage: (state) => state.brandAx.ErrorMessage,
    }),
  },
  methods: {
    ...mapActions('brandAx', ['createBrandAx', 'createBrandAx']),
    ...mapActions('brands', ['searchBrands']),
    ...mapActions('vendors', ['findVendor', 'fetchVendorsById']),

    brandFind(query) {
      if (!query) return;
      this.isBrandSearch = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        let payload = {
          name: query,
          limit: 10,
        };
        this.searchBrands(payload)
          .then((response) => {
            this.brandSearchOptions = response.data.data.rows;
            this.isBrandSearch = false;
          })
          .catch(() => {
            this.isBrandSearch = false;
          });
      }, 600);
    },

    findVendorName(keyword) {
      if (keyword.length > 2) {
        this.isLoadingSearch = true;
        let payload = {
          q: keyword,
        };
        this.findVendor(payload)
          .then((resp) => {
            this.items_vendor = resp.data.data;
            this.isLoadingSearch = false;
          })
          .catch((err) => {
            this.isLoadingSearch = false;
            console.log(err);
          });
      }
    },

    getVendorAx() {
      this.fetchVendorsById(this.vendor).then((res) => {
        this.vendor_id_ax = res.data?.data?.sync_vendor?.vendor_id_ax;
      });
    },

    addBrandAx() {
      const payload = {
        name: this.name,
        brandId: parseInt(this.brand?.id, 10),
        basePrice: parseInt(this.basePrice, 10),
        subs_Idax: this.subsIdAx,
        vendorId: this.vendor ? parseInt(this.vendor.id) : null,
        vendorName: this.vendor ? this.vendor.name : null,
        vendor_Idax: this.vendor_id_ax,
      };
      this.createBrandAx(payload);
    },

    alertMsg(msg, type) {
      this.$swal({
        icon: type,
        toast: true,
        position: 'top-end',
        title: msg,
        timer: 10000,
        text: this.message,
      });
    },
  },
};
</script>
